import SideSheetDrawer from "@/components/SidesheetDrawer";
import { MaskMultiSelect, MData } from "@/components/MaskMultiSelect";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import { useState } from "react";
import {
  ADD_PATIENT_DRAWER_WIDTH,
  ADD_PATIENT_LABEL,
} from "../group-visit-constant";

export type AddPatientDrawerProps = {
  opened: boolean;
  onClose: () => void;
  /** Patients that can be enrolled; the caller owns fetching them. */
  options: MData[];
  onSearch?: (value: string) => void;
  onSubmit: (patients: MData[]) => Promise<unknown> | void;
  isSubmitting?: boolean;
};

/**
 * Search-and-select drawer for enrolling patients into a group.
 *
 * @author Rajkumar Rathod
 */
const AddPatientDrawer = ({
  opened,
  onClose,
  options,
  onSearch,
  onSubmit,
  isSubmitting,
}: AddPatientDrawerProps) => {
  const [selected, setSelected] = useState<MData[]>([]);

  const closeAndReset = () => {
    setSelected([]);
    onClose();
  };

  const handleSubmit = async () => {
    await onSubmit(selected);
    closeAndReset();
  };

  return (
    <SideSheetDrawer
      open={opened}
      title={ADD_PATIENT_LABEL.title}
      onClose={closeAndReset}
      w={ADD_PATIENT_DRAWER_WIDTH}
      isCanvasBackground
      endIcon={
        <StyledButtonV2
          label={ADD_PATIENT_LABEL.submit}
          variant="primary"
          disabled={!selected.length || isSubmitting}
          onClick={handleSubmit}
        />
      }
    >
      <MaskMultiSelect
        label={ADD_PATIENT_LABEL.searchField}
        required
        placeholder={ADD_PATIENT_LABEL.placeholder}
        options={options}
        value={selected}
        onChange={(value) => setSelected(value ?? [])}
        onSearch={onSearch}
      />
    </SideSheetDrawer>
  );
};

export default AddPatientDrawer;
